<template>
  <div class="rounded-lg p-3 lg:p-5 bg-bg border border-bg-dark border-solid mt-5">
    <div class="flex justify-between">
      <Checkbox v-model:checked="checked" :disabled="isOngoing && hasStarted">
        <h3 class="text-xl text-primary-dark">Reward System (Gamification or fixed benefits)</h3>
      </Checkbox>

      <SaveBtn
        :disabled="!isShowCheckedSaved"
        :loading="isFetching"
        @click="handleSave"
        class="mt-0"
      />
    </div>
    <div v-if="checked">
      <div class="mt-6 bg-bg-dark p-3 rounded">
        <div class="flex flex-wrap items-end justify-between gap-3 mb-2">
          <div>
            <h4>
              Please upload your employee addresses using the following template to calculate cost :
            </h4>
            <small>(please follow the template format)</small>
          </div>
          <Button type="link" class="px-0" :disabled="isOngoing && hasStarted">
            <span class="!flex items-center gap-2">
              <span>Download addresses template</span>
              <PhDownload weight="duotone" size="18" />
            </span>
          </Button>
        </div>
        <CustumFileInput
          :disabled="isOngoing && hasStarted"
          name="file"
          :defaultData="defaultData ? defaultData.file : null"
          placeholder="choose file"
          accept=".csv"
          :rules="{
            required: false,
            min: 1,
            max: 1,
          }"
        >
          <!-- :isTouched="isAllTouched"
          @setInput="setInput"-->
          <PhFileCsv :size="22" weight="duotone" />
        </CustumFileInput>
      </div>
      <Checkbox class="mt-8" :disabled="multipliers.some(role => isPastDate(role['end_date']))" v-model:checked="checked2">
        <p class="text-md text-black">Enable point multipliers</p>
      </Checkbox>
      <template v-if="checked2">
        <Alert
          v-if="multiplierRangeWarning"
          class="mt-3 mb-4"
          type="warning"
          show-icon
          :message="multiplierRangeWarning"
        />
        <Alert
          v-if="mostRewardMonthEndWarning"
          class="mt-3 mb-4"
          type="warning"
          show-icon
          :message="mostRewardMonthEndWarning"
        />
        <div v-for="(role, index) in multipliers" v-bind:key="index">
          <div
            v-if="role['multiplier']"
            class="flex flex-col md:flex-row items-center justify-center md:justify-between gap-4"
          >
            <div class="text-center flex items-center justify-center gap-2">
              <span class="font-bold">Enter the multiplier to apply:</span>

              <InputNumber
                class="w-28"
                name="multiplier"
                v-model:value="role['multiplier']"
                :min="1"
                :disabled="isAdmin ? isPastDate(role['end_date']) : false"
              />
              <span class="font-bold">during the period from</span>
              <div class="text-center flex flex-col flex-wrap justify-center items-center gap-2">
                <div class="w-40">
                  <CustumCalender
                    :defaultData="role['start_date']"
                    name="start_date"
                    :disabled="isAdmin ? isPastDate(role['end_date']) : false"
                    defaultFormate="MMM, D, YYYY"
                    placeholder="Start Date"
                    :minDate="isAdmin ? minDate : false"
                    :rules="{
                      required: false,
                    }"
                    @setInput="(val) => setInput2(val, index)"
                  />
                </div>
              </div>
              <span class="font-bold">to</span>
              <div class="text-center flex flex-col flex-wrap justify-center items-center gap-2">
                <div class="w-40">
                  <CustumCalender
                    :defaultData="role['end_date']"
                    :disabled="isAdmin ? isPastDate(role['end_date']) : false"
                    name="end_date"
                    defaultFormate="MMM, D, YYYY"
                    placeholder="End Date"
                    :minDate="isAdmin ? minDate : false"
                    :rules="{
                      required: false,
                    }"
                    @setInput="(val) => setInput2(val, index)"
                  />
                </div>
              </div>
            </div>
            <div class="text-end">
              <span
                v-if="index == multipliers.length - 1 && index != 0 && (!isPastDate(role['end_date']))"
                @keyup="
                  () => {
                    console.log('Remove Weekly Credit');
                  }
                "
                @click="removeRole(index)"
                style="
                  font-size: 12px;
                  font-weight: bolder;
                  display: inline-block;
                  padding: 3px 6px 3px 6px;
                  border-radius: 10px;
                  background-color: #c7cbcd;
                  color: black;
                  cursor: pointer;
                "
                >-</span
              >

              <span
                v-if="index == 0"
                @click="addRole"
                @keyup="() => console.log('here')"
                style="
                  font-size: 12px;
                  font-weight: bolder;
                  display: inline-block;
                  padding: 3px 6px 3px 6px;
                  border-radius: 10px;
                  background-color: #278c64;
                  color: white;
                  cursor: pointer;
                "
                >+</span
              >
            </div>
          </div>
          <div v-if="checked2" class="text-center flex gap-2">
            <CheckboxGroup
              :disabled="isAdmin ? isPastDate(role['end_date']) : false"
              class="text-black"
              :options="options"
              v-model:value="role['modes']"
            >
            </CheckboxGroup>
          </div>
          <div v-if="checked2" class="flex flex-col">
            <div class="flex items-center gap-2">
              <span class="font-bold">Max monthly rewards per employee:</span>
              <InputNumber
                class="w-28"
                v-model:value="role['max_monthly_reward']"
                :min="0"
                :disabled="isAdmin ? isPastDate(role['end_date']) : false"
                prefix="$"
              />
              <!-- @change="setMaxRewardNum" -->
            </div>
          </div>

          <div v-if="checked2" class="text-center flex gap-2">
            <p class="text-md text-black">Other rewards</p>
            <Checkbox
              :disabled="isAdmin ? isPastDate(role['end_date']) : false"
              v-model:checked="role['most_miles_walked']"
            >
              Most Miles Walked
            </Checkbox>
            <Checkbox
              :disabled="isAdmin ? isPastDate(role['end_date']) : false"
              v-model:checked="role['most_miles_biked']"
            >
              Most Miles Biked
            </Checkbox>
            <Checkbox
              :disabled="isAdmin ? isPastDate(role['end_date']) : false"
              v-model:checked="role['most_transit_trips']"
            >
              Most Transit Trips
            </Checkbox>
            <Checkbox
              :disabled="isAdmin ? isPastDate(role['end_date']) : false"
              v-model:checked="role['most_carpool_trips']"
            >
              Most Carpool Trips
            </Checkbox>
            <Checkbox
              :disabled="isAdmin ? isPastDate(role['end_date']) : false"
              v-model:checked="role['most_green_trips']"
            >
              Most Green Trips
            </Checkbox>
            <Checkbox
              :disabled="isAdmin ? isPastDate(role['end_date']) : false"
              v-model:checked="role['most_trips_to_the_office']"
            >
              Most Trips to the Office
            </Checkbox>
            <Checkbox :disabled="isAdmin ? isPastDate(role['end_date']) : false" v-model:checked="role['weekly']">
              Weekly rewards
            </Checkbox>
          </div>

          <Spin :spinning="settingsQuery?.isFetching">
            <div class="my-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"></div>
          </Spin>
        </div>
      </template>
      <div class="mt-8">
        <div class="flex flex-col md:flex-row items-center justify-center md:justify-between gap-4">
          <div class="text-center flex items-center justify-center gap-2">
            <span class="font-bold">Number of Employees:</span>

            <InputNumber
              class="w-28"
              :defaultValue="rewardData.number_of_employees"
              disabled
              @change="setEmployeesNum"
              :min="1"
            />
          </div>

          <div class="text-center flex items-center justify-center gap-2">
            <span class="font-bold">Max monthly rewards per employee:</span>
            <InputNumber
              :disabled="isOngoing && hasStarted"
              class="w-28"
              :defaultValue="rewardData.max_reward_per_employee"
              v-model:value="max_reward_per_employee"
              :min="1"
              prefix="$"
            />
            <!-- @change="setMaxRewardNum" -->
          </div>
        </div>

        <Spin :spinning="settingsQuery?.isFetching">
          <div class="my-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <RewardCard
              title="Mode-Based"
              description="Each employee receives points based on the trip mode and allocated points in the system"
              :selected="scoring_policy_type === 'mode_based'"
              :id="'mode_based'"
              @click="() => handleSelectReward('mode_based')"
              @openModal="handleModalOpen"
            >
              <img src="@/assets/icons/reward-1.png" alt="icon" class="w-32 h-16 object-contain" />
            </RewardCard>
            <RewardCard
              :disabled="isOngoing && hasStarted"
              title="Distance-Based (Non-SOV)"
              description="Each employee receives points based on reduced SOV traveled miles"
              :selected="scoring_policy_type === 'mile_based'"
              :id="'mile_based'"
              @click="() => handleSelectReward('mile_based')"
              @openModal="handleModalOpen"
            >
              <img src="@/assets/icons/reward-2.png" alt="icon" class="w-32 h-16 object-contain" />
            </RewardCard>
            <RewardCard
              :disabled="isOngoing && hasStarted"
              title="Emission-Based"
              description="Each employee receives points based on reduced emissions accounting for vehicle type"
              :selected="scoring_policy_type === 'emission_based'"
              :id="'emission_based'"
              @click="() => handleSelectReward('emission_based')"
              @openModal="handleModalOpen"
            >
              <img src="@/assets/icons/reward-3.png" alt="icon" class="w-32 h-16 object-contain" />
            </RewardCard>
            <RewardCard
              :disabled="isOngoing && hasStarted"
              title="Fixed Benefits"
              description="Each employee receives incentives based on their commute mode choice, fully flexible to employees"
              :selected="scoring_policy_type === 'fixed_benfit'"
              :id="'fixed_benfit'"
              @click="() => handleSelectReward('fixed_benfit')"
              @openModal="handleModalOpen"
            >
              <img src="@/assets/icons/reward-4.png" alt="icon" class="w-32 h-16 object-contain" />
            </RewardCard>
          </div>
        </Spin>
      </div>

      <div class="w-full flex justify-center md:justify-end">
        <SaveBtn :disabled="!isValueChanged" :loading="isFetching" @click="handleSave" />
      </div>
    </div>

    <Modal
      :visible="visible"
      :footer="null"
      :destroyOnClose="true"
      wrap-class-name="empty-modal  "
      width="350px"
      @ok="handleModalClose"
      @cancel="handleModalClose"
    >
      <ModeBasedModal
        v-if="activeId === 'mode_based'"
        title="Specify Points per trip"
        :id="activeId"
        :key="activeId"
        @close="handleModalClose"
        :isViewOnly="isOngoing && hasStarted"
      />

      <DistanceBasedModal
        v-else-if="activeId === 'mile_based'"
        title="Specify Points per mile"
        :id="activeId"
        :key="activeId"
        @close="handleModalClose"
      />

      <EmissionBasedModal
        v-else-if="activeId === 'emission_based'"
        title="Specify Points"
        :id="activeId"
        :key="activeId"
        @close="handleModalClose"
      />
      <FixedBenefitsModal
        v-else-if="activeId === 'fixed_benfit'"
        :title="'Mode Benefits per workday'"
        :id="activeId"
        :key="activeId"
        @close="handleModalClose"
      />
    </Modal>
  </div>
</template>

<script>
/* eslint-disable */
import { Checkbox, Button, Modal, InputNumber, Spin, CheckboxGroup, Alert } from 'ant-design-vue';

import CustumFileInput from '@/components/shared/form/CustumFileInput.vue';
import { PhDownload, PhFileCsv } from 'phosphor-vue';
import { mapMutations } from 'vuex';

import debounce from 'lodash.debounce';

import RewardCard from '../shared/RewardCard.vue';
import ModeBasedModal from '../shared/ModeBasedModal.vue';
import DistanceBasedModal from '../shared/DistanceBasedModal.vue';
import EmissionBasedModal from '../shared/EmissionBasedModal.vue';
import FixedBenefitsModal from '../shared/FixedBenefitsModal.vue';
import { REWARD } from '../../../../store/types';
import SaveBtn from '../shared/SaveBtn.vue';
import CustumCalender from '@/components/shared/form/CustumCalender.vue';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const MOST_REWARD_FIELDS = [
  'most_miles_walked',
  'most_miles_biked',
  'most_transit_trips',
  'most_carpool_trips',
  'most_green_trips',
  'most_trips_to_the_office',
];

export default {
  components: {
    Checkbox,
    Button,
    CustumFileInput,
    PhDownload,
    PhFileCsv,
    InputNumber,
    RewardCard,
    FixedBenefitsModal,
    Modal,
    ModeBasedModal,
    DistanceBasedModal,
    EmissionBasedModal,
    CustumCalender,
    Spin,
    CheckboxGroup,
    SaveBtn,
    Alert,
  },
  props: {
    isOngoing: {
      type: Boolean,
      default: false,
    },
    hasStarted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: false,
      checked2: false,
      activeId: 'mile_based',
      multiplier: 2,
      visible: false,
      start_date: null,
      end_date: null,
      max_reward_per_employee: 0,
      scoring_policy_type: 'mile_based',
      options: [
        { label: 'Drive-alone', value: 'drive' },
        { label: 'Drive EV', value: 'drive_ev' },
        { label: 'Transit', value: 'transit' },
        { label: 'Walk', value: 'walk' },
        { label: 'Bike', value: 'bike' },
        { label: 'Carpool', value: 'carpool_driver' },
        { label: 'Telecommute', value: 'telecommute' },
      ],
      options2: [
        { label: 'Monthly rewards', value: 'monthly' },
        { label: 'Weekly rewards', value: 'weekly' },
      ],
      multipliers: [
        {
          multiplier: 2,
          start_date: null,
          end_date: null,
          modes: [],
          monthly: false,
          most_miles_walked: false,
          most_miles_biked: false,
          most_transit_trips: false,
          most_carpool_trips: false,
          most_green_trips: false,
          most_trips_to_the_office: false,
          max_monthly_reward: null,
          weekly: false,
        },
      ],
    };
  },

  created() {
    if (this.rewardData) {
      this.max_reward_per_employee = this.rewardData.max_reward_per_employee;
      this.scoring_policy_type = this.rewardData.scoring_policy_type;
      this.checked = this.rewardData.scoring_policy_enabled;
      this.checked2 = this.rewardData.enable_multiplier;

      const formattedMultipliers = this.rewardData?.multipliers?.map((v) => ({
        ...v,
        start_date: v?.start_date ? dayjs(v.start_date, 'YYYY-MM-DD') : null,
        end_date: v?.end_date ? dayjs(v.end_date, 'YYYY-MM-DD') : null,
      }));
      this.multipliers = formattedMultipliers ?? this.multipliers;
    }
  },
  computed: {
    isAdmin() {
      return Boolean(localStorage.getItem('is_signas')) == true ? false : true;
    },
    minDate() {
      return dayjs();
    },
    settingsQuery() {
      return this.$store.state.reward.rewardSettingsQuery;
    },
    rewardData() {
      return this.$store.getters.rewardSettingsData;
    },
    intersectingMultiplierRanges() {
      if (!this.checked2) return [];

      const ranges = this.multipliers
        .map((multiplier, index) => {
          const start = this.parseMultiplierDate(multiplier.start_date);
          const end = this.parseMultiplierDate(multiplier.end_date);

          if (!start || !end) return null;

          const normalizedStart = start.startOf('day');
          const normalizedEnd = end.endOf('day');

          if (normalizedStart.isAfter(normalizedEnd)) return null;

          return {
            index,
            start: normalizedStart,
            end: normalizedEnd,
          };
        })
        .filter(Boolean);

      const conflicts = [];

      for (let firstIndex = 0; firstIndex < ranges.length; firstIndex += 1) {
        for (let secondIndex = firstIndex + 1; secondIndex < ranges.length; secondIndex += 1) {
          if (this.doDateRangesIntersect(ranges[firstIndex], ranges[secondIndex])) {
            conflicts.push({
              firstIndex: ranges[firstIndex].index,
              secondIndex: ranges[secondIndex].index,
            });
          }
        }
      }

      return conflicts;
    },
    multiplierRangeWarning() {
      if (!this.intersectingMultiplierRanges.length) return '';

      const conflictingRows = this.intersectingMultiplierRanges
        .map(({ firstIndex, secondIndex }) => `#${firstIndex + 1} and #${secondIndex + 1}`)
        .join('; ');

      return `Point multiplier date ranges overlap between rows ${conflictingRows}. Adjust the dates so only one multiplier applies on a date.`;
    },
    mostRewardRowsMissingMonthEnd() {
      if (!this.checked2) return [];

      return this.multipliers
        .map((multiplier, index) => {
          if (!this.hasMostRewardSelected(multiplier)) return null;

          const end = this.parseMultiplierDate(multiplier.end_date);
          if (end && this.isLastDayOfMonth(end)) return null;

          return index + 1;
        })
        .filter(Boolean);
    },
    mostRewardMonthEndWarning() {
      if (!this.mostRewardRowsMissingMonthEnd.length) return '';

      const rows = this.mostRewardRowsMissingMonthEnd.map((index) => `#${index}`).join(', ');
      const rowLabel = this.mostRewardRowsMissingMonthEnd.length === 1 ? 'Row' : 'Rows';
      const verb = this.mostRewardRowsMissingMonthEnd.length === 1 ? 'has' : 'have';

      return `${rowLabel} ${rows} ${verb} a "Most *" reward selected. Set the end date to the last day of the month so monthly winners can be calculated correctly.`;
    },

    todayDate() {
      return '16-05-2022';
    },
    maxReward() {
      return this.$store.state.reward.max_reward;
    },
    employeesNumber() {
      return this.$store.state.reward.employees_number;
    },
    selectedReward() {
      return this.$store.state.reward.active_mode;
    },
    isValueChanged() {
      if (this.checked && this.checked !== this.rewardData.scoring_policy_enabled) return true;
      let isChanged = false;
      if (this.max_reward_per_employee !== this.rewardData.max_reward_per_employee) {
        isChanged = true;
      }
      if (this.scoring_policy_type !== this.rewardData.scoring_policy_type) {
        isChanged = true;
      }

      if (this.checked2 !== this.rewardData.enable_multiplier) {
        isChanged = true;
        return isChanged;
      }

      if (this.multipliers.length !== this.rewardData?.multipliers?.length && this.checked2) {
        isChanged = true;
      }
      if (this.checked2) {
        isChanged = this.multipliers?.some(
          (v, index) =>
            v.monthly != this.rewardData?.multipliers?.[index]?.monthly ||
            v.most_miles_walked != this.rewardData?.multipliers?.[index]?.most_miles_walked ||
            v.most_miles_biked != this.rewardData?.multipliers?.[index]?.most_miles_biked ||
            v.most_transit_trips != this.rewardData?.multipliers?.[index]?.most_transit_trips ||
            v.most_carpool_trips != this.rewardData?.multipliers?.[index]?.most_carpool_trips ||
            v.most_green_trips != this.rewardData?.multipliers?.[index]?.most_green_trips ||
            v.max_monthly_reward != this.rewardData?.multipliers?.[index]?.max_monthly_reward ||
            v.most_trips_to_the_office !=
              this.rewardData?.multipliers?.[index]?.most_trips_to_the_office ||
            v.weekly != this.rewardData?.multipliers?.[index]?.weekly ||
            v.multiplier != this.rewardData?.multipliers?.[index]?.multiplier ||
            (v?.start_date ? dayjs(v.start_date).format('YYYY-MM-DD') : null) !=
              (this.rewardData?.multipliers?.[index]?.start_date ?? null) ||
            (v?.end_date ? dayjs(v.end_date).format('YYYY-MM-DD') : null) !=
              (this.rewardData?.multipliers?.[index]?.end_date ?? null) ||
            v.modes?.length != this.rewardData?.multipliers?.[index]?.modes?.length ||
            !this.areArraysIdentical(v.modes, this.rewardData?.multipliers?.[index]?.modes),
        );
      }
      return isChanged;
    },
    isShowCheckedSaved() {
      return !this.checked && this.checked !== this.rewardData.scoring_policy_enabled;
    },
  },
  methods: {
    ...mapMutations([
      REWARD.SET_EMPLOYEES_NUMBER_DATA,
      REWARD.SET_MAX_REWARD_NUMBER_DATA,
      REWARD.SET_ACTIVE_MODE_DATA,
      REWARD.SET_SELECTED_SYSTEM,
    ]),
    setInput() {},
    parseMultiplierDate(date) {
      if (!date) return null;
      if (dayjs.isDayjs(date)) return date;

      const parsedDate = dayjs(date, ['YYYY-MM-DD', 'MMM, D, YYYY', 'MMMM, D, YYYY'], true);
      if (parsedDate.isValid()) return parsedDate;

      const fallbackDate = dayjs(date);
      return fallbackDate.isValid() ? fallbackDate : null;
    },
    doDateRangesIntersect(firstRange, secondRange) {
      return !firstRange.end.isBefore(secondRange.start) && !secondRange.end.isBefore(firstRange.start);
    },
    hasMostRewardSelected(multiplier) {
      return MOST_REWARD_FIELDS.some((field) => multiplier[field]);
    },
    isLastDayOfMonth(date) {
      return date.isSame(date.endOf('month'), 'day');
    },
    areArraysIdentical(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      return arr1.every((val, index) => val === arr2[index]);
    },
    handleSelectReward(id) {
      if (this.isOngoing) return;

      this.scoring_policy_type = id;
    },
    setInput2(val, index) {
      console.log(val);
      if (!this.rewardData) return;
      if (val && val.start_date && val.start_date.value) {
        this.multipliers[index].start_date = dayjs(val.start_date.value, 'MMM, D, YYYY');
      }

      if (val && val.end_date && val.end_date.value) {
        this.multipliers[index].end_date = dayjs(val.end_date.value, 'MMM, D, YYYY');
      }
    },
    handleModalClose() {
      this.visible = false;
    },
    isPastDate(date) {
      return dayjs().isAfter(dayjs(date, 'YYYY-MM-DD').endOf('day'));
    },
    handleModalOpen(id) {
      this.activeId = id;
      this.visible = true;
    },
    setEmployeesNum(val) {
      this.SET_EMPLOYEES_NUMBER_DATA(val);
    },
    setMultiplier(val) {
      this.multiplier = val;
    },
    addRole() {
      this.multipliers.push({
        multiplier: 2,
        start_date: null,
        end_date: null,
        modes: [],
        monthly: false,
        most_miles_walked: false,
        most_miles_biked: false,
        most_transit_trips: false,
        most_carpool_trips: false,
        most_green_trips: false,
        most_trips_to_the_office: false,
        max_monthly_reward: null,
        weekly: false,
      });
    },
    removeRole(index) {
      this.multipliers.splice(index, 1);
    },
    handleSave() {
      const multipliersFormat = this.multipliers.map((v) => {
        const start_date = v.start_date ? dayjs(v.start_date).format('YYYY-MM-DD') : null;
        const end_date = v.end_date ? dayjs(v.end_date).format('YYYY-MM-DD') : null;
        v.start_date = start_date;
        v.end_date = end_date;
        return v;
      });
      this.$store.dispatch(REWARD.ACTION_UPDATE_REWARD_SYS, {
        scoring_policy_type: this.scoring_policy_type,
        max_reward_per_employee: this.max_reward_per_employee,
        scoring_policy_enabled: this.checked,
        enable_multiplier: this.checked2,
        multipliers: multipliersFormat,
      });
    },
    setMaxRewardNum(val) {
      // this.SET_MAX_REWARD_NUMBER_DATA(val);
      this.debounceSetMaxRewardNum(val, this);
    },
    handleSelectSystem(e) {
      this.$store.dispatch(REWARD.ACTION_SELECT_REWARD_SYS, {
        scoring_policy_enabled: e.target.checked,
      });
      // this.SET_SELECTED_SYSTEM({
      //   type: 'is_reward_system_selected',
      //   value: e.target.checked,
      // });
    },
    debounceSetMaxRewardNum: debounce((val, app) => {
      app.$store.dispatch(REWARD.ACTION_UPDATE_REWARD_SYS, {
        max_reward_per_employee: val,
      });
    }, 600),
  },
};
</script>
<style></style>
